import { api } from '..';

export const integrationsApi = api.enhanceEndpoints({ addTagTypes: ['Integrations'] }).injectEndpoints({
  endpoints: build => ({
    getIntegration: build.query<any, { slug: string }>({
      query: ({ slug }) => ({
        url: `v1/integrations/${slug}`,
        method: 'GET',
      }),
      providesTags: ['Integrations'],
    }),
    updateIntegration: build.mutation<any, { slug: string; body: any }>({
      query: ({ slug, body }) => ({
        url: `v1/integrations/${slug}`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['Integrations'],
    }),
    toggleIntegration: build.mutation<any, { slug: string; enabled: boolean }>({
      query: ({ slug, enabled }) => ({
        url: `v1/integrations/${slug}/toggle`,
        method: 'PATCH',
        body: { enabled },
      }),
      invalidatesTags: ['Integrations'],
    }),
  }),
});

export const {
  useLazyGetIntegrationQuery,
  useUpdateIntegrationMutation,
  useToggleIntegrationMutation,
} = integrationsApi;
